import React, { FC } from 'react'
import styles from 'styles/components/calendar.module.scss'
import getDate from 'date-fns/getDate'
import isSameDay from 'date-fns/isSameDay'
import { IndividualScheduleCalendarCell } from 'components/Calendar'
import { DayOfWeekType } from 'lib/daysOfWeek'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { getClosedDates, getSpecialHolidays } from 'reducks/calendar/selectors'
import { dateToString } from 'lib/helper'

type Props = {
  activeDates: Date[]
  businessDays: DayOfWeekType[]
  currentMonth: Date
  handleCaution: (flag: boolean) => void
  individualSettingDates: Date[]
  row: Date[]
  selectSettingDate: (date: Date) => void
}

const IndividualScheduleCalendarRow: FC<Props> = (props) => {
  const { activeDates, currentMonth, handleCaution, individualSettingDates, row, selectSettingDate } = props
  const closedDates = useSelector((state: State) => getClosedDates(state))
  const specialHolidays = useSelector((state: State) => getSpecialHolidays(state))
  return (
    <tr className={styles.table__row}>
      {row.map((date) => {
        const isActive = activeDates.some((activeDate) => isSameDay(activeDate, date))
        const isClosed = closedDates.some((closedDate) => isSameDay(closedDate, date))
        const isSpecialHoliday = specialHolidays.some((specialHoliday) => specialHoliday.date === dateToString(date))
        const isSet = individualSettingDates.some((individualSettingDate) => isSameDay(individualSettingDate, date))
        return (
          <IndividualScheduleCalendarCell
            currentMonth={currentMonth}
            key={getDate(date)}
            date={date}
            handleCaution={handleCaution}
            isActive={isActive}
            isClosed={isClosed}
            isSet={isSet}
            isSpecialHoliday={isSpecialHoliday}
            selectSettingDate={selectSettingDate}
          />
        )
      })}
    </tr>
  )
}

export default IndividualScheduleCalendarRow
